import React from 'react';
import {apiFetch} from '../../api/apiClient';
import AppIcon from './AppIcon';
import styles from '../Management.module.css';

type Props={value?:string|null;onChange:(path:string|null)=>Promise<void>|void;disabled?:boolean;onBusyChange?:(busy:boolean)=>void};
export default function IconPicker({value,onChange,disabled=false,onBusyChange}:Props):React.ReactElement {
  const id=React.useId(),[busy,setBusy]=React.useState(false),[error,setError]=React.useState('');
  async function change(file?:File){
    if(!file||busy||disabled)return;
    setError('');
    if(file.size>256*1024){setError('Choose a PNG image up to 256 KB.');return;}
    setBusy(true);onBusyChange?.(true);
    try{
      const response=await apiFetch('/api/app-icons',{method:'POST',headers:{'Content-Type':'image/png'},body:file});
      const result=await response.json() as {iconPath?:string;error?:string};
      if(!response.ok||!result.iconPath)throw new Error(result.error||'The icon could not be uploaded.');
      await onChange(result.iconPath);
    }catch(e){setError(e instanceof Error?e.message:'The icon could not be changed.');}
    finally{setBusy(false);onBusyChange?.(false);}
  }
  async function reset(){
    setError('');setBusy(true);onBusyChange?.(true);
    try{await onChange(null);}catch(e){setError(e instanceof Error?e.message:'The default icon could not be restored.');}
    finally{setBusy(false);onBusyChange?.(false);}
  }
  return <div className={styles.iconPicker}>
    <div className={styles.titleRow}><AppIcon iconPath={value}/><span>{value?'Custom application icon':'Conductor default icon'}</span></div>
    <label className={styles.field} htmlFor={id}>Application icon (optional)<input id={id} type="file" accept="image/png,.png" disabled={disabled||busy} onChange={event=>{const file=event.target.files?.[0];event.target.value='';void change(file);}}/></label>
    <small className={styles.muted}>Square PNG, 16–512 pixels, up to 256 KB.</small>
    {value&&<button type="button" className={styles.button} disabled={disabled||busy} onClick={()=>void reset()}>Use Conductor icon</button>}
    {busy&&<span role="status">Saving icon…</span>}
    {error&&<p role="alert" className={styles.error}>{error}</p>}
  </div>;
}
